import { join, map } from 'lodash';
import { normalizeIncludeInReports } from 'application/util/event-report.util';

export default class BalanceService {
    /* @ngInject */
    constructor($q, apiService) {
        this.$q = $q;
        this.apiService = apiService;
    }

    getMonthlyBalances(calendarIds, from, to) {
        return this.apiService.get(`/calendars/overview`, {
            params: {
                from,
                to,
                calendars: join(calendarIds, ',')
            }
        }).then((result) => result.data || []);
    }

    getDailyBalances(calendarIds, from, to) {
        return this.apiService.get(`/calendars/days`, {
            params: {
                from,
                to,
                calendars: join(calendarIds, ',')
            }
        }).then((result) => {
            const data = result.data || {};
            return Object.assign({}, data, {
                transactions: map(data.transactions || [], (event) => normalizeIncludeInReports(event))
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/application/service/calendar/balance.service.js